import { useState, useEffect, useCallback } from "react";

const MAX = 4;
const KEY = "compare-ids";

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

function readStorage(): string[] {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function useCompare() {
  const [ids, setIds] = useState<string[]>(readStorage);

  useEffect(() => {
    const sync = () => setIds(readStorage());
    listeners.add(sync);
    return () => { listeners.delete(sync); };
  }, []);

  const toggle = useCallback((id: string) => {
    const current = readStorage();
    const next = current.includes(id)
      ? current.filter((i) => i !== id)
      : current.length < MAX ? [...current, id] : current;
    localStorage.setItem(KEY, JSON.stringify(next));
    setIds(next);
    notify();
  }, []);

  const clear = useCallback(() => {
    localStorage.setItem(KEY, "[]");
    setIds([]);
    notify();
  }, []);

  const isComparing = useCallback((id: string) => ids.includes(id), [ids]);

  return { ids, toggle, clear, isComparing, count: ids.length };
}
